import { render } from "./AposPagerDots.vue?vue&type=template&id=e5aee882&scoped=true"
import script from "./AposPagerDots.vue?vue&type=script&lang=js"
export * from "./AposPagerDots.vue?vue&type=script&lang=js"

import "./AposPagerDots.vue?vue&type=style&index=0&id=e5aee882&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5aee882"],['__file',"ui/ui/apos/components/AposPagerDots.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5aee882"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5aee882', __exports__)) {
    api.reload('e5aee882', __exports__)
  }
  
  module.hot.accept("./AposPagerDots.vue?vue&type=template&id=e5aee882&scoped=true", () => {
    api.rerender('e5aee882', render)
  })

}


export default __exports__